import { getToken, axios } from '../../settings'
import {
    logoutUrl
} from '../api'

export const logoutApiAction = async() => {
    return await axios
        .get(logoutUrl(), getToken())
        .then(function ({ data: x }) {
        })
        .catch(function (error) {
            console.log("logout err", error)
        })
}

